/**
 * The header language <select> (DEN-99 §5). Anonymous only for now: a change
 * is `setLocale` (writes the cookie), no request. Signed-in persistence to the
 * account's `locale` returns with each area's auth.
 */
import { Select } from '../ui/atoms/Select';
import { useLocale, useT } from './I18nProvider';
import { SUPPORTED_LOCALES, LOCALE_ENDONYMS } from './config';

const LOCALE_OPTIONS = SUPPORTED_LOCALES.map((l) => ({
  id: l,
  label: LOCALE_ENDONYMS[l],
}));

export function LocaleSelect({ className }: { className?: string }) {
  const { locale, setLocale } = useLocale();
  const { t } = useT();

  return (
    <span className={className}>
      <Select
        size="sm"
        aria-label={t('i18n.localeSelect:label')}
        options={LOCALE_OPTIONS}
        value={locale}
        onChange={setLocale}
      />
    </span>
  );
}
